import environment from '@/modules/cart/environments/environment';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';

const { CART_URL } = environment;

const CART_OUT_OF_STOCK_URL = `${CART_URL}/out-of-stock-item`;

export async function removeOutOfStockProducts(): Promise<{
  data: HttpCartDto;
}> {
  return httpClient.delete(`${CART_OUT_OF_STOCK_URL}`);
}
